// extracted by mini-css-extract-plugin
export default {"root":"Replies_root__lSYh8","top":"Replies_top__58sGE","main":"Replies_main__NY2g2","listTop":"Replies_listTop__4FrRB","list":"Replies_list__fsaRv"};